import React from 'react';
import { AspectRatio, Thumbnail } from '@nimbus-ds/components';

interface DocumentUploaderSkeletonProps {
  aspectRatio: AspectRatio;
}

function DocumentUploaderSkeleton({
  aspectRatio,
}: DocumentUploaderSkeletonProps): JSX.Element {
  return <Thumbnail.Skeleton aspectRatio={aspectRatio} />;
}

export default DocumentUploaderSkeleton;
